import React from "react";

import Button from "../../components/Button";

import {
  coverImage,
  stockRows,
  formatPrice,
  formatQuantity,
  displayName,
  arePricesVisible,
  priceCurrency,
} from "./stuffedFormat";
import { en, es } from "../../languages/langs";

const SEX_LABEL_KEYS = {
  male: "Male",
  female: "Female",
  unknown: "Sex is unknown",
  pair: "Pair",
};

const StuffedItem = ({ record, activeLang, onAddToInquiry, isInInquiry }) => {
  const lang = { en, es }[activeLang];
  const image = coverImage(record.images);
  const rows = stockRows(record);
  const pricesVisible = arePricesVisible(record);
  const currency = priceCurrency(record);

  return (
    <div className="row catalog-item stuffed-item mobile-p-left__large mobile-p-right__large mobile-m-top__x-large">
      <div className="column size__one-of-two mobile-size__one-of-two">
        <div className="square-container image-button__container">
          {image ? (
            <div
              className="square-container image-button__img-container"
              style={{ backgroundImage: `url('${image.src}')` }}
              role="img"
              aria-label={image.alt || displayName(record, activeLang)}
            ></div>
          ) : (
            <div
              className="square-container image-button__img-container stuffed-item__no-image"
              data-testid="stuffed-image-placeholder"
            >
              <span className="green-text">{lang["No photo available"]}</span>
            </div>
          )}
        </div>
      </div>
      <div className="column size__one-of-two p-left__medium mobile-size__one-of-two">
        <h4 className="catalog-item__title green-text p-right__medium m-bottom__mediumsmall">
          {displayName(record, activeLang)}
        </h4>
        <span className="stuffed-item__line">
          <i>{record.scientific_name}</i>
        </span>
        {record.taxidermy_status === "in_process" && (
          <span className="stuffed-item__badge green-background creme-text">
            {lang["Being prepared"]}
          </span>
        )}
        <span className="stuffed-item__line" data-testid="stuffed-located-at">
          {record.located_at}
        </span>
        {record.age && <span className="stuffed-item__line">{record.age}</span>}
        {record.size && (
          <span className="stuffed-item__line">{record.size}</span>
        )}
        <ul className="stuffed-item__stock m-top__small">
          {rows.map((row) => {
            // A price hidden by region and a sex that was never priced are
            // different things, and say different things to the buyer.
            const price = pricesVisible
              ? formatPrice(row.price, currency) || lang["price on request"]
              : lang["Contact us for pricing"];
            return (
              <li key={row.sex} data-testid={`stuffed-stock-${row.sex}`}>
                {`${lang[SEX_LABEL_KEYS[row.sex]]}: ${formatQuantity(
                  row.quantity,
                )} — ${price}`}
              </li>
            );
          })}
        </ul>
        {record.is_illustration && (
          <span className="stuffed-item__illustration-note">
            <i>{lang.species_illustration_note}</i>
          </span>
        )}
        <Button
          extraClasses="m-top__medium"
          disabled={isInInquiry}
          onClick={() => {
            if (!isInInquiry) {
              onAddToInquiry(record.id);
            }
          }}
        >
          {isInInquiry ? lang["Added to inquiry"] : lang["Add to inquiry"]}
        </Button>
      </div>
    </div>
  );
};

export default StuffedItem;
